import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild  } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, Table } from 'primeng/table';
import { RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { AdminService } from '../../../../services/admin.service';
import { HttpClient } from '@angular/common/http';

/*----Prime NG----*/
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { FormsModule } from "@angular/forms";

import { AutoComplete } from 'primeng/autocomplete';
@Component({
  selector: 'app-admin-home',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, TableModule, InputTextModule, InputIconModule, IconFieldModule, FormsModule, AutoComplete],
  providers: [Base64UrlService],
  templateUrl: './admin-home.component.html',
  styleUrl: './admin-home.component.css'
})
  
export class AdminHomeComponent {
  @ViewChild('dt2', { static: false }) dt2: any;
  userName: any;
  lang: any;
  associatesList: any[] = [];
  monthDropdown: any;
  userCode: any;
  // These hold filtered data
  visibleData: any[] = [];
  totalCount: number = 0;
  dropDowndate: any;
  branchDropdown: any[] = [];
  customerDropdown: any[] = [];
  selectedBranch: any = '-1';
  selectedCustomer: any = '-1';
  selectedDate: string = '';
  weekEndingDate: string = '';
  displayByCompany: boolean = false;
  filteredBranchs: any[] = [];
  selectedBranchId: number = -1;
  nonSearchable: boolean = true;
  selectedCustomerId: number = -1;
  filteredCustomers: any[] = [];

  constructor(private auth: AuthService, private translate: TranslateService, private ts: TimesheetService, private as: AdminService, private en: EncryptionService, private pageTitle: PageTitleService, private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'en');
      // console.log(this.lang)
      translate.use(this.lang);
    }
  }
  

  ngOnInit() {
    this.userName = this.auth.getName();
    this.userCode = this.auth.getCode();
    this.pageTitle.setTitle('menu.timesheet');
    if (isPlatformBrowser(this.platformId)) {
      this.selectedBranch = { branchID: -1, branchName: this.translate.instant('All') };
      this.selectedCustomer = { customerID: -1, customerName: this.translate.instant('All') };
      this.getAssociates();
    }
  }

  getAssociates() {
    this.ts.getMonthListV2()
      .subscribe({
        next: (resMonthList: any) => {
          this.monthDropdown = resMonthList.data;
          // console.log(this.monthDropdown);
          const [day, month, year] = resMonthList.data[0].dayDate.split('-');
          let newFormat = `${year}-${month}-${day}`;
          this.selectedDate = `${day}-${month}-${year}`;
          // this.getAssociatesList(newFormat);
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout(); 
			return	
          }
        }
      });
    
    this.as.getBranches()
      .subscribe({
        next: (resBranchList: any) => {
          this.branchDropdown = resBranchList.data;
          // console.log(this.branchDropdown);
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout(); 
			return;	
          }
        }
      });    

  }

  onSearch() {
    // console.log('Branch:', this.selectedBranch.branchId);
    // console.log('Customer:', this.selectedCustomer.customerID);
    // console.log('Date:', this.selectedDate);
    if (this.selectedDate) {
      this.weekEndingDate = this.getDate(this.selectedDate);
    } else {
      this.weekEndingDate = '';
    }
    if (this.selectedCustomerId === undefined || this.selectedCustomerId === null) {
      this.selectedCustomerId = -1;
    }
    if (this.selectedBranchId === undefined || this.selectedBranchId === null) {
      this.selectedBranchId = -1;
    }
    const filters = {
      weekEndingDate: this.weekEndingDate,
      companyId: this.selectedCustomerId,
      departmentId: this.selectedBranchId
    }
    if (this.selectedCustomer === '-1') {
      // console.log("list company")
      this.displayByCompany = false;
      this.getCompanyList(filters);
    } else {
      // console.log("list Section");
      this.getAssociatesList(filters);
    }
  }

  onCmpSearch(compId: any) {
    this.selectedCustomer = compId;
    this.onSearch();
  }

  clearAll() {
    // this.selectedDate = '';
    this.selectedCustomer = { customerID: -1, customerName: this.translate.instant('All') };
    this.selectedBranch = { branchID: -1, branchName: this.translate.instant('All') };
    this.totalCount = 0;
    this.displayByCompany = false;
    this.nonSearchable = true;
    this.associatesList = [];
  }
  // fncCng(event: any) {
  //   let dateFormat = this.getDateFromEvent(event);
  //   this.getAssociatesList(dateFormat);
  // }

  private getDateFromEvent(event: any): string {
    if (!event) return '2025-07-01';
    const target = event.target as HTMLSelectElement;
    return this.getDate(target.value);
  }

  getCompanyList(filtersObj: any) {

    this.as.getCompanyList(filtersObj)
      .subscribe({
        next: (res: any) => {
          // this.associatesList = this.applyEncryption(res.data);
          if (res.status) {
            this.associatesList = res.data;
            // this.totalCount = this.associatesList.length;
            setTimeout(() => this.updateVisibleData(), 0);            
          } else {
            this.associatesList = [];
          }
          this.totalCount = this.associatesList.length;
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			return
          }
        }
      });

  }

  getAssociatesList(filtersObj: any) {

    this.as.getAssociatesByCompany(filtersObj)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            // this.associatesList = this.applyEncryption(res.data);
            // this.associatesList = res.data;

            this.associatesList = this.applyEncryption(res.data).map((item: any) => {
              const searchParts: string[] = [];

              // Section name
              searchParts.push(item.sectionName);

              // Names from timesheetSummary
              item.timesheetSummary.forEach((t: any) => {
                searchParts.push(
                  t.section,          // name
                  t.contractTerm,
                  t.userid?.toString()
                );
              });

              return {
                ...item,
                searchText: searchParts.join(' ').toLowerCase()
              };
            });
            
            this.displayByCompany = true;
            setTimeout(() => this.updateVisibleData(), 0);            
          } else {
            this.associatesList = [];
          }
          this.totalCount = this.associatesList.length;
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			      return
          }
        }
      });

  }

  ngAfterViewInit() {
    // Initially set to full dataset
    // this.filteredData = [...this.associatesList];
    // setTimeout(() => this.updateVisibleData(), 0);
  }

  applyFilterGlobal($event: Event) {
    const input = $event.target as HTMLInputElement;
    this.dt2.filterGlobal(input.value, 'contains');
    // Table triggers onFilter after this
  }

  // Update filteredData whenever filter or pagination changes
  onFilter(event: any) {
    this.updateVisibleData();
  }

  onPage(event: any) {
    this.updateVisibleData(event);
  }

  onSort() {
    this.updateVisibleData();
  }

  updateVisibleData(event?: any) {   
    if (!this.dt2) {
      this.visibleData = this.associatesList;
      return;
    }
    const filtered = this.dt2.filteredValue ?? this.associatesList;
    const start = event?.first ?? this.dt2.first ?? 0;
    const rows = event?.rows ?? this.dt2.rows ?? 3;
    const end = start + rows;
    this.visibleData = filtered.slice(start, end);
  }

  // Compute totals dynamically
  get totalRegular() {
    // return this.visibleData.reduce((sum:any, item: any) => sum + (item.regular || 0), 0);
    
    let totalTime = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.regular;

      if (!timeStr) return sum; // skip null/undefined/empty

      // Split into parts safely
      const parts = String(timeStr).split(':').map(Number);

      let h = 0, m = 0, s = 0;
      // if (parts.length === 3) [h, m, s] = parts;
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (isNaN(h) || isNaN(m)) return sum; // skip invalid

      return sum + (h * 3600 + m * 60);
    }, 0);

    return this.formatSeconds(totalTime);
  }
  
  get totalOverTime() {
    // return this.visibleData.reduce((sum:any, item: any) => sum + (item.overtime || 0), 0);
    let totalTime = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.overtime;
      if (!timeStr) return sum; // skip null/undefined/empty
      // Split into parts safely
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
     
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (isNaN(h) || isNaN(m)) return sum; // skip invalid

      return sum + (h * 3600 + m * 60);
    }, 0);

    return this.formatSeconds(totalTime);
  }
  get totalMn() {
    // return this.visibleData.reduce((sum:any, item: any) => sum + (item.midnightOvertime || 0), 0);
    let totalTime = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.midnightOvertime;
      if (!timeStr) return sum; // skip null/undefined/empty
      // Split into parts safely
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
     
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (isNaN(h) || isNaN(m)) return sum; // skip invalid

      return sum + (h * 3600 + m * 60);
    }, 0);

    return this.formatSeconds(totalTime);
  }
  get overAllTotal() {
    // return this.visibleData.reduce((sum:any, item: any) => sum + (item.total || 0), 0);
    let totalTime = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.total;
      if (!timeStr) return sum; // skip null/undefined/empty
      // Split into parts safely
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
     
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (isNaN(h) || isNaN(m)) return sum; // skip invalid

      return sum + (h * 3600 + m * 60);
    }, 0);

    return this.formatSeconds(totalTime);
  }
  get totalNotSubmit() {
    // return this.visibleData.reduce((sum:any, item: any) => sum + (item.notSubmit || 0), 0);
    let totalTime = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.notSubmit;
      if (!timeStr) {
        // console.log("here - "+timeStr);
        return sum; // skip null/undefined/empty
      }  
      // Split into parts safely
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
     
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (isNaN(h) || isNaN(m)) return sum; // skip invalid

      return sum + (h * 3600 + m * 60);
    }, 0);

    return this.formatSeconds(totalTime);
  }
  get totalSubmit() {
    // return this.visibleData.reduce((sum:any, item: any) => sum + (item.submit || 0), 0);
    let totalTime = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.submit;
      if (!timeStr) return sum; // skip null/undefined/empty
      // Split into parts safely
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
     
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (isNaN(h) || isNaN(m)) return sum; // skip invalid

      return sum + (h * 3600 + m * 60);
    }, 0);

    return this.formatSeconds(totalTime);
  }
  get totalReject() {
    // return this.visibleData.reduce((sum:any, item: any) => sum + (item.reject || 0), 0);
    let totalTime = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.reject;
      if (!timeStr) return sum; // skip null/undefined/empty
      // Split into parts safely
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
     
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (isNaN(h) || isNaN(m)) return sum; // skip invalid

      return sum + (h * 3600 + m * 60);
    }, 0);

    return this.formatSeconds(totalTime);
  }
  get totalApprove() {
    // return this.visibleData.reduce((sum:any, item: any) => sum + (item.approve || 0), 0);
    let totalTime = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.approve;
      if (!timeStr) return sum; // skip null/undefined/empty
      // Split into parts safely
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
     
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (isNaN(h) || isNaN(m)) return sum; // skip invalid

      return sum + (h * 3600 + m * 60);
    }, 0);

    return this.formatSeconds(totalTime);
  }
  get totalHome() {
    // return this.visibleData.reduce((sum:any, item: any) => sum + (item.teleWork || 0), 0);
    let totalTime = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.teleWork;
      if (!timeStr) return sum; // skip null/undefined/empty
      // Split into parts safely
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
     
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (isNaN(h) || isNaN(m)) return sum; // skip invalid

      return sum + (h * 3600 + m * 60);
    }, 0);

    return this.formatSeconds(totalTime);
  }
  get totalAbsence() {
    // return this.visibleData.reduce((sum:any, item: any) => sum + (item.absence || 0), 0);
    let totalTime = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.absence;
      if (!timeStr) return sum; // skip null/undefined/empty
      // Split into parts safely
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
     
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (isNaN(h) || isNaN(m)) return sum; // skip invalid

      return sum + (h * 3600 + m * 60);
    }, 0);

    return this.formatSeconds(totalTime);
  }
  get totalPh() {
    // return this.visibleData.reduce((sum:any, item: any) => sum + (item.paidHoliday || 0), 0);
    let totalTime = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.paidHoliday;
      if (!timeStr) return sum; // skip null/undefined/empty
      // Split into parts safely
      const parts = String(timeStr).split(':').map(Number);
      let h = 0, m = 0;
     
      if (parts.length === 2) [h, m] = parts;
      else if (parts.length === 1) h = parts[0];

      if (isNaN(h) || isNaN(m)) return sum; // skip invalid

      return sum + (h * 3600 + m * 60);
    }, 0);

    return this.formatSeconds(totalTime);
  }

  get totalResource() {
    let totalResource = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.userCount;
      if (!timeStr) return sum; // skip null/undefined/empty      

      return sum + timeStr ;
    }, 0);

    return totalResource;
  }

  get totalContract() {
    let totalContract = this.visibleData.reduce((sum: number, item: any) => {
      const timeStr = item?.userCount;
      if (!timeStr) return sum; // skip null/undefined/empty      

      return sum + timeStr ;
    }, 0);

    return totalContract;
  }

  get totalRegularSection() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.regular;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }  
  get totalOverTimeSection() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.overtime;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalMnSection() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.midnightOvertime;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get overAllTotalSection() {
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.total;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalNotSubmitSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.notSubmit;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
    
  }
  get totalSubmitSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.submit;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalRejectSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.reject;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalApproveSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.approve;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalHomeSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.teleWork;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalAbsenceSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.absence;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }
  get totalPhSection() {
    // console.log(this.visibleData);
    if (!this.visibleData || this.visibleData.length === 0) return '00:00';
    let totalSeconds = 0;

    this.visibleData.forEach((customer: any) => {
      if (!customer.timesheetSummary) return;

      customer.timesheetSummary.forEach((admin: any) => {
        const timeStr = admin?.paidHoliday;
        if (!timeStr) return;

        // Split into hours/minutes
        const parts = String(timeStr).split(':').map(Number);
        let h = 0, m = 0;

        if (parts.length === 2) [h, m] = parts;
        else if (parts.length === 1) h = parts[0];

        if (!isNaN(h) && !isNaN(m)) {
          totalSeconds += (h * 3600 + m * 60);
        }
      });
    });
    return this.formatSeconds(totalSeconds);
  }

  formatSeconds(totalTime: number): string {
    const hours = Math.floor(totalTime / 3600);
    const minutes = Math.floor((totalTime % 3600) / 60);
    // const seconds = totalTime % 60;
    // :${ this.pad(seconds) }
    return `${hours}:${this.pad(minutes)}`;
  }

  pad(num: number): string {
    return num.toString().padStart(2, '0');
  }
  
  getMonthYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  }
  getMonth(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short'});
  }
  getYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { year: 'numeric'});
  }
  getDate(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

  applyEncryption(dt: any) {
    dt.forEach((elm: any, ind: any) => {
      elm.timesheetSummary.forEach((obj: any, index: any) => {
        const encryptedId = Base64UrlService.encode(
          this.en.encryptionAES(obj.timesheetId.toString())
        );
        const encryptedUserId = Base64UrlService.encode(
          this.en.encryptionAES(obj.userid.toString())
        );
        elm.timesheetSummary[index].timesheetId = encryptedId;
        elm.timesheetSummary[index].userid = encryptedUserId;
      }) 
    });
    return dt;
  }

  onGlobalFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dt2.filterGlobal(value, 'contains');
  }

  filterBranch(event: any) {
    var query = event.query.toLowerCase();
    
    let list = [
      { branchId: -1, branchName: this.translate.instant('All') },
      ...this.branchDropdown
    ];
    if (!query) {
      this.filteredBranchs = list;
      return;
    }
    this.filteredBranchs = list.filter(c =>
      c.branchName.toLowerCase().includes(query)
    );
  }
  onSelectBranch(event: any) {
    console.log(event.value.branchId);
    this.selectedBranchId = event.value.branchId;
    if (this.selectedBranchId > 0) { 
      console.log("not all")
      this.as.getCustomersByBranch(this.selectedBranchId)
        .subscribe({
          next: (resCustmomersList: any) => {
            this.customerDropdown = resCustmomersList.data??[];
            console.log(this.customerDropdown);
            this.nonSearchable = false;
          },
          error: (err: any) => {
            if(err.status === 401) {
              this.auth.logout();    
              return	
            }
          }
        });
    } else {
      this.customerDropdown = [];
      this.nonSearchable = true;
    }
      // return
      
    // }
  }
  
  filterCustomer(event: any) {
    const query = (event.query || '').toLowerCase();//event.query.toLowerCase();
    const list = [
      { customerId: -1, customerName: this.translate.instant('All') },
      ...this.customerDropdown
    ];
    if (!query) {
      this.filteredCustomers = list;
      return;
    }
    this.filteredCustomers = list.filter(c =>
      c.customerName.toLowerCase().includes(query)
    );
  }
  onSelectCustomer(event: any) {
    // console.log(event.value.customerID);
    if (!event?.value) {
      this.selectedCustomerId = -1;
      return;
    }
    // console.log(this.selectedCustomerId)
    this.selectedCustomerId = event.value.customerID;
  }

  onCustomerChange(value: any) {
  if (!value) {
    // Reset selection
    this.selectedCustomerId = -1;

    // Show "All" again
    this.filteredCustomers = [
      { customerId: -1, customerName: this.translate.instant('All') },
      ...this.customerDropdown
    ];
  }
}
}
